import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=2896f038&scoped=true"
var script = {}
import style0 from "./PrintPage.vue?vue&type=style&index=0&id=2896f038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896f038",
  null
  
)

export default component.exports